module.exports = __webpack_public_path__ + "img/best_price-green.26107761.png";